export default __webpack_public_path__ + "static/media/segment-dark.fe71c91f.svg";